import FocusTrap from "./FocusTrap";

class MenuDesktop {
    activeClassFirstDepth = "open-item";
    activeClassSecondDepth = "open-item";
    trap = null;

    constructor(selector) {
        this._handleClick = this._handleClick.bind(this);
        this._clickEverything = this._clickEverything.bind(this);

        this.selector = selector;
        this.items = this.selector.querySelectorAll('[data-element="expand"]');

        if (this.items.length) {
            this.event();
        }
    }

    event() {
        this.items.forEach((item) => {
            item.addEventListener("click", this._handleClick);
        });

        document.addEventListener("click", this._clickEverything);
    }

    _handleClick(event) {
        event.preventDefault();
        let item = event.target.closest('[data-element="expand"]');

        if (item.getAttribute("aria-expanded") === "true") {
            this.hideItem(item);
        } else {
            this.hideAllItems(this.getDepth(item));
            this.showItem(item);
            this.trap = new FocusTrap(item.nextElementSibling, item, true);
        }
    }

    getDepth(item) {
        return parseInt(item.getAttribute("data-depth"));
    }

    showItem(item) {
        if (this.getDepth(item) === 1) {
            item
                .closest(".menu-item-has-children")
                .classList.add(this.activeClassSecondDepth);
        } else {
            item
                .closest(".menu-item-has-children")
                .classList.add(this.activeClassFirstDepth);
        }
        item.setAttribute("aria-expanded", "true");
    }

    hideItem(item) {
        if (this.getDepth(item) === 1) {
            item
                .closest(".menu-item-has-children")
                .classList.remove(this.activeClassSecondDepth);
        } else {
            item
                .closest(".menu-item-has-children")
                .classList.remove(this.activeClassFirstDepth);
        }

        item.setAttribute("aria-expanded", "false");
    }

    hideAllItems(depth = -1) {
        this.items.forEach((item) => {
            if (depth === -1 || this.getDepth(item) === depth) {
                this.hideItem(item);
            }
        });
    }

    _clickEverything(event) {
        const isClickInsideElement = this.selector.contains(event.target);

        if (!isClickInsideElement) {
            this.hideAllItems();
        }
    }
}

export default MenuDesktop;
